// @flow
import React from 'react';

type Props = {
  question1: string,
  question2: string,
  question2Part2: string,
  question2Part3: string,
  question3: string,
};

const OutcomeText = ({
  question1,
  question2,
  question2Part2,
  question2Part3,
  question3,
}: Props) => {
  if (question2Part3) {
    return (
      <>
        <div style={{ marginBottom: '4px' }}>Your Ansarada free trial is ready and set up:</div>
        <ul>
          <li>
            <strong>{question2.split('|')[2]}</strong>
          </li>
          <li>
            <strong>{question2Part2.split('|')[1]}</strong>
          </li>
          <li>
            <strong>{question1}</strong>
          </li>
          <li>
            <strong>{question2Part3.split('|')[1]}</strong>
          </li>
        </ul>
        <div>
          You’re currently <strong>{question3}</strong>
        </div>
      </>
    );
  }
  if (question2 === 'Other') {
    return 'We’ve prepared your Ansarada free trial.';
  }
  let whatTheyAreDoing = null;
  if (question2 || question2Part2) {
    whatTheyAreDoing =
      question2 && question2Part2 ? (
        <>
          <strong>{question2}</strong> and <strong>{question2Part2}</strong>
        </>
      ) : (
        <strong>{question2 || question2Part2}</strong>
      );
  }
  const whereTheyAreAt = question3 ? (
    <>
      , and you are currently <strong>{question3}</strong>
    </>
  ) : null;
  const whoTheyAre = <strong>{question1}</strong>;
  const outcomeText = whatTheyAreDoing ? (
    <>
      We&lsquo;ve prepared your Ansarada free trial for {whatTheyAreDoing} in {whoTheyAre}
      {whereTheyAreAt}
    </>
  ) : (
    <>We’ve prepared your Ansarada free trial</>
  );

  return <span>{outcomeText}.</span>;
};
export default OutcomeText;
